import React, { useState, useEffect, useMemo } from 'react';
import { supabase } from '../supabase';

const C = { purple:'#691FB1', purpleLight:'#C6C3E7', pink:'#FF357B', blue:'#57B1DD', txt:'#2b2b3a', soft:'#6b6b7b' };
const eur = n => (Number(n)||0).toLocaleString('pt-PT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
const ym  = d => d ? new Date(d).toISOString().slice(0,7) : '';

export default function VendasView({ perms, userEmail, voltar }){
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fMes, setFMes] = useState('');
  const [fComercial, setFComercial] = useState('');

  useEffect(()=>{ (async()=>{
    const { data } = await supabase.from('vendas').select('*').order('data_venda',{ascending:false}).limit(5000);
    setVendas(data||[]); setLoading(false);
  })(); },[]);

  const comerciais = useMemo(()=>[...new Set(vendas.map(v=>v.comercial_nome||v.comercial_email).filter(Boolean))].sort(),[vendas]);
  const meses = useMemo(()=>[...new Set(vendas.map(v=>ym(v.data_venda)).filter(Boolean))].sort().reverse(),[vendas]);

  const filtradas = useMemo(()=>vendas.filter(v=>
    (!fMes || ym(v.data_venda)===fMes) &&
    (!fComercial || (v.comercial_nome||v.comercial_email)===fComercial)
  ),[vendas,fMes,fComercial]);

  const totVal = filtradas.reduce((s,v)=>s+(Number(v.valor)||0),0);
  const totCom = filtradas.reduce((s,v)=>s+(Number(v.comissao_valor)||0),0);

  const exportCSV = () => {
    const head = ['Numero','Data','Cliente','Linha','Modelo','Tipo negocio','Valor s/IVA','Comissao %','Comissao','Comercial'];
    const rows = filtradas.map(v=>[
      v.numero||'', (v.data_venda||'').slice(0,10), v.cliente||'', v.linha||'', v.billing_model||'',
      v.tipo_negocio||'', (Number(v.valor)||0).toFixed(2), (Number(v.comissao_pct)||0).toFixed(2),
      (Number(v.comissao_valor)||0).toFixed(2), v.comercial_nome||v.comercial_email||''
    ]);
    const csv = [head,...rows].map(r=>r.map(c=>'"'+String(c).replace(/"/g,'""')+'"').join(';')).join('\n');
    const blob = new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'});
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = 'vendas'+(fMes?'_'+fMes:'')+'.csv'; a.click();
  };

  const btn = (active)=>({ background:active?C.purple:C.purpleLight, color:active?'#fff':C.purple, border:'1px solid '+C.purple, borderRadius:8, padding:'7px 13px', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700 });
  const sel = { padding:'8px 12px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt };

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", color:C.txt, padding:'24px 32px', boxSizing:'border-box', width:'100%' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:18, flexWrap:'wrap', gap:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <button onClick={voltar} style={btn(false)}>← Voltar</button>
          <h2 style={{ margin:0, fontSize:20, color:C.purple }}>📒 Registo de vendas</h2>
        </div>
        <button onClick={exportCSV} style={{ ...btn(false), background:C.blue, color:'#fff', border:'1px solid '+C.blue }}>⬇ Exportar CSV</button>
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
        <select value={fMes} onChange={e=>setFMes(e.target.value)} style={sel}>
          <option value=''>Todos os meses</option>
          {meses.map(m=><option key={m} value={m}>{m}</option>)}
        </select>
        <select value={fComercial} onChange={e=>setFComercial(e.target.value)} style={sel}>
          <option value=''>Todos os comerciais</option>
          {comerciais.map(c=><option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div style={{ display:'flex', gap:12, marginBottom:18, flexWrap:'wrap' }}>
        <div style={{ background:C.purpleLight, borderRadius:12, padding:'14px 20px', minWidth:160 }}>
          <div style={{ fontSize:12, color:C.purple, fontWeight:700 }}>VENDAS</div>
          <div style={{ fontSize:22, fontWeight:800, color:C.purple }}>{filtradas.length}</div>
        </div>
        <div style={{ background:C.purpleLight, borderRadius:12, padding:'14px 20px', minWidth:160 }}>
          <div style={{ fontSize:12, color:C.purple, fontWeight:700 }}>VALOR s/IVA</div>
          <div style={{ fontSize:22, fontWeight:800, color:C.purple }}>{eur(totVal)}</div>
        </div>
        <div style={{ background:C.purpleLight, borderRadius:12, padding:'14px 20px', minWidth:160 }}>
          <div style={{ fontSize:12, color:C.purple, fontWeight:700 }}>COMISSÕES</div>
          <div style={{ fontSize:22, fontWeight:800, color:C.purple }}>{eur(totCom)}</div>
        </div>
      </div>

      {loading ? <p style={{ color:C.soft }}>A carregar…</p> :
       filtradas.length===0 ? <p style={{ color:C.soft }}>Sem vendas para este filtro.</p> :
      <div style={{ overflowX:'auto', width:'100%', maxWidth:'100%', WebkitOverflowScrolling:'touch' }}>
        <table style={{ width:'100%', minWidth:760, borderCollapse:'collapse', fontSize:13, tableLayout:'auto' }}>
          <thead>
            <tr style={{ borderBottom:'2px solid '+C.purpleLight, textAlign:'left', color:C.purple }}>
              <th style={{ padding:'9px 8px' }}>Nº</th>
              <th style={{ padding:'9px 8px' }}>Data</th>
              <th style={{ padding:'9px 8px' }}>Cliente</th>
              <th style={{ padding:'9px 8px' }}>Linha</th>
              <th style={{ padding:'9px 8px' }}>Tipo</th>
              <th style={{ padding:'9px 8px', textAlign:'right' }}>Valor s/IVA</th>
              <th style={{ padding:'9px 8px', textAlign:'right' }}>Comissão</th>
              <th style={{ padding:'9px 8px' }}>Comercial</th>
            </tr>
          </thead>
          <tbody>
            {filtradas.map(v=>(
              <tr key={v.id} style={{ borderBottom:'1px solid #eee' }}>
                <td style={{ padding:'9px 8px', fontWeight:700 }}>{v.numero}</td>
                <td style={{ padding:'9px 8px' }}>{(v.data_venda||'').slice(0,10)}</td>
                <td style={{ padding:'9px 8px' }}>{v.cliente}</td>
                <td style={{ padding:'9px 8px' }}>{v.linha}</td>
                <td style={{ padding:'9px 8px' }}>{v.tipo_negocio}</td>
                <td style={{ padding:'9px 8px', textAlign:'right' }}>{eur(v.valor)}</td>
                <td style={{ padding:'9px 8px', textAlign:'right' }}>{eur(v.comissao_valor)} <span style={{ color:C.soft, fontSize:11 }}>({(Number(v.comissao_pct)||0)}%)</span></td>
                <td style={{ padding:'9px 8px' }}>{v.comercial_nome||v.comercial_email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>}
    </div>
  );
}
